import React from "react";
import { Content, Line, MLabel, SHeader, Wrapper } from "./styles";
import dayjs from "dayjs";
import { DELIVERY_TIME_ORDER, SALESSLIP_STATUS } from "Common";
import ButtonBack from "components/ButtonBack";
import GoodsItem from "../GoodsItem";
import { Box, Button } from "@mui/material";

const CanDeleteFlagButtonText = {
  0: { color: "inherit", text: "削除不可" },  //default
  1: { color: "secondary", text: "削除" },
  2: { color: "secondary", text: "モリエンへ削除依頼" },
  3: { color: "inherit", text: "削除不可" },
  4: { color: "inherit", text: "モリエンへ削除依頼済" },

}

const OrderDetails = ({ order, handleAddToCard, handleBack, handleDeleteOrder }) => {



  const GetCanDeleteFlag = (orderTop) => {
    // 削除可能かどうかのステータス：1-削除可能｜2-削除依頼可能｜3-削除不可 | 4-削除依頼済

    var flag = 3;
    if (!orderTop) return flag;
    // OrderTopID < 2: 削除不可（Stageの伝票）
    // SalesSlipID < 2: 削除可能　（伝票未発行）
    // SalesSlipStatusID < 301: 削除依頼可能（伝票発行済み、未出荷）
    // SalesSlipStatusID >= 301: 削除不可（出荷済み）
    // DelRequested = 1: 削除依頼済
    if (orderTop.OrderTopID < 2) return 3;  //3-削除不可
    if (orderTop.SalesSlipID < 2) return 1; // 1-削除可能　（伝票未発行）
    if (orderTop.DelRequested > 0) return 4; //4-削除依頼済
    if (orderTop.SalesSlipStatusID < 301 && orderTop.DelRequested < 1) return 2; //2-削除依頼可能
    return 3; //Default: 3-削除不可
  }

  const orderTop = order?.length > 0 ? order[0] : null;
  const canDeleteFlag = GetCanDeleteFlag(orderTop);
  const strDeliverryDate = orderTop?.SalesSlipStatusID < 1 ? SALESSLIP_STATUS[1] : dayjs(orderTop.DeliveryDate).format("YYYY年MM月DD日") + DELIVERY_TIME_ORDER[orderTop?.DeliveryTimeID || 1] + SALESSLIP_STATUS[orderTop.SalesSlipStatusID || 1];

  return <Wrapper>
    {!!orderTop ? (
      <Content>
        <Line>
          <MLabel>現場：</MLabel>
          {orderTop.SiteName}
        </Line>
        <Line>
          <MLabel>住所：</MLabel>
          {`${orderTop.DeliveryTo || ''}${orderTop.DeliveryPref || ''}${orderTop.DeliveryCity || ''}${orderTop.DeliveryAdrNumber || ''}`}
        </Line>
        <Line>
          <MLabel>受注日：</MLabel>
          {orderTop.AcceptedDate || '―'}
        </Line>
        <Line>
          <MLabel>配達タイプ：</MLabel>
          {orderTop.DeliveryTypeID || '―'}
        </Line>
        <Line>
          <MLabel>配送日：</MLabel>
          {strDeliverryDate}
        </Line>
        <Line>
          <MLabel>メモ：</MLabel>
          {orderTop.OrderTopMemo || ''}
        </Line>
        <Box mr={2} mb={1} mt={1} textAlign="right">
          {/* Button Delete */}
          <Button variant="contained" color={CanDeleteFlagButtonText[canDeleteFlag || 0]?.color || "inherit"} onClick={() => { if (canDeleteFlag !== 3 && canDeleteFlag !== 4) handleDeleteOrder(); }}>
            {CanDeleteFlagButtonText[canDeleteFlag || 0]?.text || "削除不可"}
          </Button>
        </Box>
        <SHeader>商品一覧</SHeader>
        {order.map(item => <GoodsItem key={`${item.SalesSlipID}${item.GoodsID}${item.GoodsSubID}`} item={item}
          handleAddToCard={() => { handleAddToCard(item) }} />)}
      </Content>
    ) : "該当データがなし"}
    <ButtonBack onHandleBack={() => { handleBack(); }} />
  </Wrapper >
};

export default OrderDetails;
